import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {ExtendedGameModel} from "../../server/ExtendedGameModel";
import {HOTB} from "../../HOTB";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {GameConfig} from "../../GameConfig";
import {gsap} from "gsap";

export class AvalancheBetPresentation implements FlowStatePresentation {
    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        const gameModel: ExtendedGameModel = HOTB.model,
            tl: gsap.core.Timeline = gsap.timeline({
                onComplete: (): void => {
                    flowStateController.finish();
                }
            });

        if (gameModel.data.nextMode === ExtendedGameMode.NORMAL_AVALANCHE) {
            gameModel.nearWinReels = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => false);
        }

        if (tl.duration() === 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }
}